import React from "react";
import { IAddressInformation } from "../../../../store/credit/types";
interface IProps {
    data?: IAddressInformation[];
}
const PrintCreditHistoryAddressInfo: React.FunctionComponent<IProps> = (props) => {
    let col = null;
    if (props.data != null) {
        col = props.data;
    }
    return (
        <React.Fragment>
            <div className="box offset-padding">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-text">
                            <h2 className="box-title" id="print-credit-history-address-info">
                                Address Information
                            </h2>
                        </div>
                    </div>
                    <div className="box-description"></div>
                    <div className="box-actions"></div>
                </div>

                <div className="box-content">
                    {col != null ? (
                        <div className="table-container scroll">
                            <table className="m-table-generic">
                                <thead>
                                    <tr>
                                        <th scope="col">
                                            <span className="sr-only"></span>
                                        </th>
                                        {col.map((addressInfo: IAddressInformation) => (
                                            <th key={addressInfo.bureau + "_addressInfoBureau"} scope="col">
                                                {addressInfo.bureau}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row" className="table-label">
                                            Address
                                        </th>
                                        {col.map((addressInfo: IAddressInformation) => (
                                            <td key={addressInfo.bureau + addressInfo.order + "_addressInfo"}>{addressInfo.address}</td>
                                        ))}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default PrintCreditHistoryAddressInfo;
